import {Button, Grid, Typography} from '@material-ui/core'
import React from 'react'
import {useLocation} from 'react-router-dom'

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const Home = () => {
  let query = useQuery()
  const sponsorParam = query.get("sponsor")
  const queryParams = (sponsorParam !== null)?`?sponsor=${sponsorParam}`:""
  return (
    <div style={{ margin: 20 }}>
      <Grid alignItems="center" alignContent="center" justify="center" container spacing={4}>
        <Grid item xs={12}>
          <div style={{ margin: '50px 0', justifyContent: 'center', alignItems: 'center'}}>
            <Typography
              align="center"
              variant="body1"
              gutterBottom
              color="textPrimary">
              Escolha sua conta
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} md={4}>
          <Button color="default" variant="contained" fullWidth href="/individual?sponsor=sistemaparalelo">Sem patrocinador? Clique aqui</Button>
        </Grid>
        <Grid item xs={12} md={4}>
          <Button color="default" variant="contained" fullWidth href={`/individual${queryParams}`}>Para mim</Button>
        </Grid>
        <Grid item xs={12} md={4}>
          <Button color="default" variant="contained" fullWidth href={`/empresas${queryParams}`}>Para minha empresa</Button>
        </Grid>
        <Grid item xs={12} md={4}>
          <Button color="default" variant="contained" fullWidth href={`/parceiros${queryParams}`}>Desejo ser um parceiro</Button>
        </Grid>
        <Grid item xs={12} md={4}>
          <Button color="default" variant="contained" fullWidth href="https://www.instagram.com/sistema_paralelo/">Saiba Mais!</Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default Home;
